import CSS from 'csstype';
import React from 'react';

import {
  getCustomTag,
  getResponsiveStyle,
  getSpacingStyle,
  ILayoutProps,
  ISpacingProps,
  spacing,
} from '~/src/dash/components/layout/common';
import { useBaseState } from '~/src/dash/views/base/contexts';

interface IDivProps extends ILayoutProps, ISpacingProps {
  onClick?: (props: any | null) => void;
  onHover?: (props: any | null) => void;
  onLeave?: (props: any | null) => void;
  flex?: boolean;
  displayFlex?: boolean;
}

export const Div = ({
  onClick,
  onHover,
  onLeave,
  displayFlex,
  noPadding,
  extraSmallPadding,
  smallPadding,
  basePadding,
  largePadding,
  extraLargePadding,
  hugePadding,
  noHorizontalPadding,
  extraSmallHorizontalPadding,
  smallHorizontalPadding,
  horizontalPadding,
  largeHorizontalPadding,
  extraLargeHorizontalPadding,
  hugeHorizontalPadding,
  noVerticalPadding,
  extraSmallVerticalPadding,
  smallVerticalPadding,
  verticalPadding,
  largeVerticalPadding,
  extraLargeVerticalPadding,
  hugeVerticalPadding,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
  marginTop,
  marginRight,
  marginBottom,
  marginLeft,
  style,
  responsive,
  extraLargeStyle,
  largeStyle,
  mediumStyle,
  smallStyle,
  extraSmallStyle,
  children,
  innerRef,
  className = '',
  tag,
  cypressID,
}: IDivProps) => {
  const mediaSize = responsive ? useBaseState().mediaSize : 'extraSmall';
  const addOptionalStyles = () => {
    const styles = {} as CSS.Properties;
    if (displayFlex) {
      styles.display = 'flex';
    }
    if (onClick) {
      styles.cursor = 'pointer';
    }
    return styles;
  };

  const divStyle: CSS.Properties = {
    ...getCustomTag('DIV', tag),
    position: 'relative',
    ...addOptionalStyles(),
    ...getSpacingStyle({
      defaultPadding: spacing.none,
      noPadding,
      extraSmallPadding,
      smallPadding,
      basePadding,
      largePadding,
      extraLargePadding,
      hugePadding,
      noHorizontalPadding,
      extraSmallHorizontalPadding,
      smallHorizontalPadding,
      horizontalPadding,
      largeHorizontalPadding,
      extraLargeHorizontalPadding,
      hugeHorizontalPadding,
      noVerticalPadding,
      extraSmallVerticalPadding,
      smallVerticalPadding,
      verticalPadding,
      largeVerticalPadding,
      extraLargeVerticalPadding,
      hugeVerticalPadding,
      paddingTop,
      paddingRight,
      paddingBottom,
      paddingLeft,
      marginTop,
      marginRight,
      marginBottom,
      marginLeft,
    }),
    ...style,
    ...getResponsiveStyle({
      responsive,
      mediaSize,
      extraLargeStyle,
      largeStyle,
      mediumStyle,
      smallStyle,
      extraSmallStyle,
    }),
  };

  return (
    <div
      ref={innerRef}
      {...(onClick && { onClick })}
      {...(onHover && { onMouseEnter: onHover })}
      {...(onLeave && { onMouseLeave: onLeave })}
      className={className}
      data-cy={cypressID}
      style={divStyle}
    >
      {children}
    </div>
  );
};
